import { ChangeDetectorRef, Component, EventEmitter, Injector, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Attribute } from '@app/shared/interfaces/Attribute';
import { FilterType } from '@app/shared/interfaces/front-end-column';
import { BaseProductComponent } from '@product/shared/base-product.component';
import { CatalogProduct, CatalogUpdate, TransformedProduct } from '@product/shared/models/catalog';
import { FilterObject, ListPayload } from '@product/shared/models/ListPayload';
import { Product } from '@product/shared/models/product';
import { catchError, forkJoin, map, Observable, of, switchMap, tap, throwError } from 'rxjs';
import { productColumns } from '@product/shared/product-base-logic';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { FilterOperator } from '@product/shared/models/Enums.enum';
import { ProductSelectorComponent } from '@product/product-selector/product-selector.component';
import { DynamicCatalogComponent } from '../dynamic-catalog/dynamic-catalog.component';
import { NzImageService } from 'ng-zorro-antd/image';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageType } from '../ImageType.enum';


@Component({
  selector: 'app-ProductCatalog',
  templateUrl: './ProductCatalog.component.html',
  styleUrls: ['./ProductCatalog.component.less'],

})
export class ProductCatalogComponent extends BaseProductComponent implements OnInit {
  receivedProducts: any[] = [];
  selectedImageUrl: string = '';
  isFiltersCleared: boolean = false;
  tabIndex: string = "";
  catalogName: string = '';
  mode: string = '';
  catalogForm: FormGroup;
  isLoadingProducts: boolean = false;
  catalogId: number = 0;
  catalogCode: string = '';
  bannerMediaObjectId: number = 0;
  thumbnailMediaObjectId: number = 0;
  visible = false;
  selectedProductsOld: number[] = [];
  // displayedProducts: Product[] = [];
  displayedProducts: any[] = [];
  // selectedProducts: Product[] = [];
  selectedProducts: Set<{
    id: number;
    sku: string;
    name: string;
    type: string;
  }> = new Set();
  products: Product[] = [];
  isLoading: boolean;
  productsCount: number;
  shareableLink: string = '';
  isCopied: boolean = false;
  productsCatalog: CatalogProduct;
  searchValue: string = '';
  previewImageUrl: string | ArrayBuffer | null = null;
  previewBannerUrl: string | ArrayBuffer | null = null;

  imageUrlThumbnail: string = '';
  imageUrlBanner: string = '';
  thumbUrl: any;
  bannerUrl: any;
  ImageType = ImageType;
  productsLoading: boolean = false;
  attributes: Attribute[] = [];
  hideSizeChanger:boolean=false;

  savedFilters: { [key: string]: FilterObject } | null = {};
  listColumns = productColumns;
  selectedProductsOld2: Set<Product> = new Set();
  @ViewChild(ProductSelectorComponent) productSelector: ProductSelectorComponent;
  @ViewChild(DynamicCatalogComponent) dynamicCatalog: DynamicCatalogComponent;
  drawerPayload: ListPayload = {
    SearchValue: '',
    Filters: {},
    IsAscend: false,
    SortBy: 'Id',
    PageIndex: 0,
    PageSize: 10,
    ApplyAllFilters: false,
    Attributes: []
  };

  productTableParams = {
    index: 1,
    size: 10,
  };

  selectedId = 0;
  drawerProducts: Product[] = [];
  drawerTotalCount = 0;
  isDrawerLoading = false;
  filter: any;
  currencies: any[] = [];
  selectedProductIds: number[] = [];
  ids:any;
  //Ids:number[]=[];
 // typeCatalog:boolean=false;
  properties = [
    { title: 'Price', formControlName: 'productPricePropertyName' },
    { title: 'Description', formControlName: 'productDescriptionPropertyName' },
    { title: 'Main Image', formControlName: 'productMainImagePropertyName' },
    { title: 'Image', formControlName: 'productImagesPropertyName' }
  ];

  checked = false;
  indeterminate = false;
  setOfCheckedIds = new Set<number>();
  isFrontPagination:boolean=false;
  listOfSelection = [
    {
      text: 'Select All',
      onSelect: () => {
   
          this.checked = true;
        this.selectAllCatalogProducts(true);
      
      }
    },
 {
      text: 'Select All In Page',
      onSelect: () => {
          this.displayedProducts.forEach(product=>{
            this.setOfCheckedIds.add(product.id);
          })
 this.indeterminate = true;
        
      }
    },
    {
      text: 'Deselect',
      onSelect: () => {
        this.setOfCheckedIds.clear();
        this.indeterminate = false;
        this.checked = false;

      }
    }
  ];

  constructor(
    injector: Injector,
    private imageService: NzImageService,
    private satitizer: DomSanitizer,
  ) {
    super(injector);
  }
selection(id: any): void {
  
  if (this.setOfCheckedIds.has(id)) {
    this.setOfCheckedIds.delete(id);
  } else {
    this.setOfCheckedIds.add(id);
  }
}


selectAllCatalogProducts(selectByIds: boolean,deleteAfterSelect:boolean=false){
 
  this.productCatalog.selectAllCatalogProducts(this.catalogId).subscribe(
    {
      next:(data)=>{
        if(selectByIds){

         this.ids = data.map((product: any) => product.id);

          data.forEach((item:any) => {
          this.setOfCheckedIds.add(item.id)   
          });

          if (deleteAfterSelect && this.setOfCheckedIds.size > 0) {
          this.bullkDelete();
          }
          
      }else{
        const extractedProducts = data.map((product:any) => ({
        id: product.id,
        name: product.name,
        sku: product.sku,
        type: product.type
      }));
      this.selectedProductsOld2 = new Set(extractedProducts);
      }
      }
    }
  )

}

  ngOnInit() {
    this.initForm();
    this.getAllCurrencies();
    this.getAtributes();
    this.getRouteParam();

 
  // const catalogId = this.catalogId;
  // const savedTabIndex = localStorage.getItem(`tabIndex_${catalogId}`);
  // this.tabIndex = savedTabIndex || 'Manual';
 
  }


  initForm(): void {
    this.catalogForm = this.fb.group({
      shareableLink: [{ value: '' }],
      name: ['', [Validators.required, Validators.minLength(2)]],
      description: ['', [Validators.required, Validators.minLength(2)]],
      productPricePropertyName: [''],
      productDescriptionPropertyName: [''],
      productMainImagePropertyName: [''],
      productImagesPropertyName: [''],
      bannerMediaObjectId: [0],
      thumbnailMediaObjectId: [0],
      availableAttributes: [[]],
      currency: [''],
      type: ['Manual'] ,
      catalogProducts: this.fb.array([]),
    });
  }

  get catalogProducts(): FormArray {
    return this.catalogForm.get('catalogProducts') as FormArray;
  }

  generateLink() {
    const basePath: string = "/product-catalog/catalog-cards/";
    const url = `${window.location.origin}${basePath}${this.catalogId}/${this.catalogCode}?catalogName=${this.catalogName}`;
    this.shareableLink = url;
    this.catalogForm.patchValue({
      shareableLink: this.shareableLink
    }, { emitEvent: false });

  }
  getRouteParam() {
    this.route.queryParams.subscribe(queryParams => {

      this.catalogName = queryParams['catalogName'];
    });
    this.route.params.subscribe((params) => {
      if (params['id'] || params['catalogCode']) {
        this.mode = 'edit';
        this.catalogId = +params['id'];
        this.catalogCode = params['catalogCode'];
        this.getCatalogProducts();
        this.generateLink();
      }
      else {
        this.mode = 'create';
        this.tabIndex='Manual'
        this.catalogForm.patchValue({
          shareableLink: '',

        }, { emitEvent: false })
      }
    });



  }

  // method managment catalog
  bullkDelete() {
    const idsToDelete = this.setOfCheckedIds.size > 0
    ? Array.from(this.setOfCheckedIds)
    : this.ids;

  if (idsToDelete.length === 0) {
    return; 
  }
  this.productCatalog.bulkDeleteCatalogProducts(this.catalogId, idsToDelete).subscribe({
    next: (data) => {
    this.message.success('Products deleted successfully');
    this.getCatalogProducts();
    this.indeterminate = false;
    this.checked = false;
    this.setOfCheckedIds.clear();
    },
    error:(error)=>{
     this.message.error('Failed to delete products');
    }
   
  });
 

  }




  

 deleteProduct(id: number): void {
  const ids = [id];
  this.productCatalog.bulkDeleteCatalogProducts(this.catalogId, ids).subscribe({
    next: (response) => {
      this.message.success('Product deleted successfully')
        this.indeterminate = false;
        this.checked = false;
      this.getCatalogProducts();
    },
    error: (err) => {
      this.message.error('Error occurred while deleting the product:');
    }
  });
}



  getCatalogProducts() {
    this.productsLoading = true;
    this.hideSizeChanger=true;
    this.productCatalog.getCatalogProducts(this.catalogId, this.catalogCode,
      this.productTableParams.index,
      this.productTableParams.size,
     
    )
      .pipe(
        switchMap((catalogData) => {
          this.productsCatalog = catalogData;

          const thumbnailRequest = this.getImageUrl(catalogData.thumbnailMediaObjectId, this.catalogCode);
          const bannerRequest = this.getImageUrl(catalogData.bannerMediaObjectId, this.catalogCode);


          return forkJoin({
            catalogData: of(catalogData),
            thumbnailUrl: thumbnailRequest,
            bannerUrl: bannerRequest
          });
        }),
        switchMap(({ catalogData, thumbnailUrl, bannerUrl }) => {
          this.thumbUrl = thumbnailUrl;
          this.bannerUrl = bannerUrl;

          const selectedAttributes = catalogData.availableAttributes
            ? catalogData.availableAttributes.split(',').map((attr: any) => Number(attr.trim()))
            : [];


       
          this.catalogForm.patchValue({
            name: catalogData.name,
            description: catalogData.description,
            availableAttributes: selectedAttributes,
            thumbnailMediaObjectId: catalogData.thumbnailMediaObjectId,
            bannerMediaObjectId: catalogData.bannerMediaObjectId,
            productPricePropertyName: catalogData.productPricePropertyName,
            productDescriptionPropertyName: catalogData.productDescriptionPropertyName,
            productMainImagePropertyName: catalogData.productMainImagePropertyName,
            productImagesPropertyName: catalogData.productImagesPropertyName,
            currency: catalogData.currency,
            type: catalogData.type
          });

           
           this.tabIndex = catalogData.type === 'Smart' ? 'Smart' : 'Manual';

          if (!catalogData.products || catalogData.products.length === 0) {
            this.productsLoading = false;
            this.displayedProducts = [];
            return of([]);
          }

          const productImageObservables = catalogData.products.map((product: any) =>
            this.getImageUrlByCode(product.imageCode).pipe(
              map(imageBase64 => ({
                ...product,
                mainImage: imageBase64
              }))
            )
          );
          return forkJoin(productImageObservables);
        })
      )
      .subscribe((productsWithImages: any) => {


        this.displayedProducts = productsWithImages.map((product: any) => ({
          id: product.id,
          name: product.name,
          price: product.price,
          description: product.description,
          mainImage: product.mainImage,
          sku: product.sku,
          availableAttributes: product.availableAttributes
        }));

 
        
        this.productsLoading = false;
        this.isFrontPagination=false;
        
      }, (error) => {
        console.error("Error ", error);
        this.productsLoading = false;
          this.hideSizeChanger=true;
      });
  }

  addCatalog() {
 
    if (this.catalogForm.valid) {
   
      const availableAttrs = this.catalogForm.get('availableAttributes')?.value;
      const availableAttributesString = availableAttrs.join(',');
      this.catalogForm.patchValue({
        availableAttributes: availableAttributesString
      });
      const bannerMediaObjectId = this.getMediaId('Banner', 'bannerMediaObjectId');
      const thumbnailMediaObjectId = this.getMediaId('Normal', 'thumbnailMediaObjectId');
      this.catalogForm.patchValue({
        bannerMediaObjectId: bannerMediaObjectId,
        thumbnailMediaObjectId: thumbnailMediaObjectId
      });

      delete this.catalogForm.value.shareableLink;
    const updates = this.displayedProducts.map(product => ({
      productId: product.id as number,
    }));

      const catalogProductsFormArray = this.catalogForm.get('catalogProducts') as FormArray;


      // catalogProductsFormArray.clear();

      updates.forEach(item => {
        catalogProductsFormArray.push(new FormGroup({
          productId: new FormControl(item.productId),
        }));
      });

   this.catalogForm.patchValue({
          type: this.tabIndex
      })
      const formValue = { ...this.catalogForm.value };
      delete formValue.shareableLink;
      this.subscriptions.push(
        this.productCatalog.addCatalog(this.catalogForm.value).pipe(

          switchMap((data) => {

            if (data && data.id) {
              this.message.success('Catalog added successfully!');
              localStorage.removeItem('Banner');
              localStorage.removeItem('Normal');

              if (this.filter !== undefined && this.filter !== null) {
                return this.productCatalog.addListPayload(data.id, 20, this.filter);
              }
              return of(null);
            } else {

              return throwError('Invalid response');
            }
          })
        ).subscribe({
          next: (response) => {
            this.filter = {};
            this.router.navigate(['/product-catalog/catalog-list']);

          },

        })
      );
    } else {
    this.catalogForm.markAllAsTouched();
      this.message.error('Please check your field and try again.');
          return;
    }

  }

  updateCatalog() {
    
    this.productsLoading = true;
    const availableAttrs = this.catalogForm.get('availableAttributes')?.value;
    const availableAttributesString = availableAttrs.join(',');


    const updates: CatalogUpdate[] = this.displayedProducts.map(product => ({
      catalogId: this.catalogId,
      productId: product.id as number,
    }));

  
    const bannerMediaObjectId = this.getMediaId('Banner', 'bannerMediaObjectId');
    const thumbnailMediaObjectId = this.getMediaId('Normal', 'thumbnailMediaObjectId');
    const catalogObject = {
      id: this.catalogId,
      name: this.catalogForm.get('name')?.value,
      description: this.catalogForm.get('description')?.value,
      bannerMediaObjectId: bannerMediaObjectId,
      thumbnailMediaObjectId: thumbnailMediaObjectId,

      productPricePropertyName: this.catalogForm.get('productPricePropertyName')?.value,
      productDescriptionPropertyName: this.catalogForm.get('productDescriptionPropertyName')?.value,
      productMainImagePropertyName: this.catalogForm.get('productMainImagePropertyName')?.value,
      productImagesPropertyName: this.catalogForm.get('productImagesPropertyName')?.value,
      currency: this.catalogForm.get('currency')?.value,
      translations: [],
      type:this.tabIndex,
      availableAttributes: availableAttributesString,
      catalogProducts: updates,
    };
    
    //   catalogProducts: updates,
    this.subscriptions.push(
      this.productCatalog.updateCatalog(catalogObject, this.catalogId).pipe(
        switchMap((response) => {

          this.message.success('Catalog updated successfully');
          localStorage.removeItem('Banner');
          localStorage.removeItem('Normal');
          // if (this.isFiltersCleared) {
          //   return this.productCatalog.deleteListPayload(this.catalogId, 20);
          // } else {
          //   return this.productCatalog.editListPayload(this.catalogId, 20, this.filter);
          // }
        if (this.selectedProductIds?.length) {
          return this.productCatalog.bulkAddCatalogProducts(this.catalogId, this.selectedProductIds).pipe(
            // tap(() => this.message.success('Products added to catalog successfully')),
            catchError((err) => {
              this.message.error('Add products failed');
              return of(null); 
            })
          );
        }

        return of(null);

        }),
        switchMap(() => {
        // if (this.isFiltersCleared) {
        //   return this.productCatalog.deleteListPayload(this.catalogId, 20);
        // } else {
        //   return this.productCatalog.editListPayload(this.catalogId, 20, this.filter);
        // }
           return this.productCatalog.deleteListPayload(this.catalogId, 20).pipe(

         switchMap(() => {
          
         const filters = this.filter.filters || this.filter.Filters;
          console.log('filtersss ',filters);
          
           if(filters && Object.keys(filters).length > 0){
                return this.productCatalog.addListPayload(this.catalogId, 20, this.filter);
           }
           return of();
            })
       );
      

      })
      ).subscribe({
        next: (response) => {
          this.filter = {};
          this.productsLoading = false;
          this.dynamicCatalog.getListPayload(this.catalogId);
          this.getCatalogProducts();
          //  this.router.navigate(['/product-catalog/catalog-list']);
        },
        error: (error) => {
          console.error('Error updating catalog:', error);
          this.productsLoading = false;
        }
      })
    );


  }

  onSearch() {

    if (!this.searchValue) {
      if (this.productsCatalog?.products?.length) {
        this.displayedProducts = this.productsCatalog.products;
      } else {
        this.displayedProducts = this.receivedProducts;
      }
    }
    else {
      this.searchValue = this.searchValue.trim();
      this.displayedProducts = this.displayedProducts.filter(
        (product: any) =>
          product.name.toLowerCase().includes(this.searchValue.toLowerCase()) ||
          product.sku.toLowerCase().includes(this.searchValue.toLowerCase())
      ).map(this.transformProduct);
    }
  }

  transformProduct(product: any) {
    return {
      id: product.id,
      name: product.name,
      sku: product.sku,
      type: product.type
    };

  }


  // Method to display products in drawer
  getProducts() {

    this.isLoadingProducts = true;
    this.subscriptions.push(
      this.productService
        .getProductsList(this.drawerPayload)
        .pipe(
          tap((response) => {
            this.products = response.records;
            this.productsCount = response.recordsCount;
            this.isLoadingProducts = false;


            this.selectedProductsOld = this.displayedProducts
              .map((attr: any) => attr.id)
              .filter((id: any) =>
                this.products.some((attribute: any) => attribute.id === id));


            this.isLoading = false;

          })
        )
        .subscribe()
    );
  }
  handleFilterChanges(updatedFilters: { [key: string]: FilterObject }) {
    this.savedFilters = updatedFilters;
    this.drawerPayload.Filters = { ...this.savedFilters };
    this.getProducts();
  }



handleProductSelection(selectedProducts: any) {
  if (!Array.isArray(selectedProducts) || selectedProducts.length === 0) return;


  let ids: number[] = [];

  const areAllObjects = selectedProducts.every(
    item => typeof item === 'object' && item !== null && 'id' in item
  );

  if (areAllObjects) {
    const uniqueProducts = Array.from(
      new Map((selectedProducts as Product[]).map(product => [product.id, product])).values()
    );
     this.displayedProducts = [...uniqueProducts];


    //this.mergeIntoDisplayedProducts(uniqueProducts);
    ids = uniqueProducts
      .map(product => product.id)
      .filter((id): id is number => id !== undefined); 
  } else {
      this.hideSizeChanger=false;
  this.isFrontPagination=true;
    ids = Array.from(new Set(
      (selectedProducts as number[] | any[])
        .map(product =>
          typeof product === 'object' && product !== null ? product.id : product
        )
        .filter((id): id is number => id !== undefined) 
    ));
    
    // get All products
       this.connectionService.get(
        `${AppConfigService.settings.dataApiUrl}Product`,
        (response) => {
          
          const value = response.value as any[];
          //const fetchedProducts
           this.displayedProducts 
           = value.map((product) => {
            return {
              id: product.Id,
              name: product.Name,
              sku: product.Sku,
              type: product.Type
            };
          });
          // this.isFrontPagination=true;
        //       const filtered = fetchedProducts.filter(p => ids.includes(p.id));
        // this.mergeIntoDisplayedProducts(filtered);
        }

      );

  
      
  }
  this.selectedProductIds = ids;

 this.productsCatalog.productCount=this.displayedProducts.length;
 this.isFrontPagination=true;
}
 private mergeIntoDisplayedProducts(products: Product[]) {
  const combinedProducts = [
    ...this.displayedProducts,
    ...products
  ];

  this.displayedProducts = Array.from(
    new Map(combinedProducts.map(product => [product.id, product])).values()
  );
}

// addProductsToCatalog() {
//   if (!this.catalogId || !this.selectedProductIds?.length) return;

//   this.productCatalog.bulkAddCatalogProducts(this.catalogId, this.selectedProductIds).subscribe({
//     next: () => {
//     this.message.success('Products added to catalog successfully');
//     this.getCatalogProducts();
//     },
//     error: (err) => {
//       this.message.error('Add products failed', err);
//     }
//   });
// }



  handleFiltersChanges(filter: any) {
    if (filter == null) return;
    // deleting the filter if the value was null or empty
    const additionalInfo = JSON.parse(filter.filter?.AdditionalInfo ?? '{}');
    if (
      (['', null, undefined, 'null'].includes(filter.filter?.Value?.trim()) &&
        additionalInfo.needValue == null) ||
      (additionalInfo.needValue != null && additionalInfo.needValue === true)
    ) {
      delete this.drawerPayload.Filters[filter.code];
    }
    const keys = Object.keys(this.drawerPayload.Filters);

    if (keys.includes(filter.code)) {
      this.drawerPayload.Filters[filter.code] = filter.filter;
    } else if (
      !['', null, undefined, 'null'].includes(filter.filter?.Value) ||
      additionalInfo.needValue === false
    ) {
      this.drawerPayload.Filters = {
        ...this.drawerPayload.Filters,
        [filter.code]: filter.filter,
      };
    }
    this.getProducts();
  }

  refreshDrawerProducts() {
    this.getDrawerProducts();
  }

  getDrawerProducts() {
    this.drawerPayload.Filters = { ...this.savedFilters };
    this.drawerPayload.Filters['Id'] = {
      Operator: FilterOperator.isNotEqual,
      Type: FilterType.Number,
      Value: this.selectedId.toString(),
      AdditionalInfo: '',
    };
    this.isDrawerLoading = true;
    return this.productService.getProductsList(this.drawerPayload).pipe(
      tap((response) => {
        this.drawerProducts = response.records;
        this.drawerTotalCount = response.recordsCount;
        this.isDrawerLoading = false;
      }),
      catchError((error) => {
        this.isDrawerLoading = false;
        return of([]);
      })
    );
  }

  openProductSelector() {
    this.productSelector.openDrawer();

    this.selectAllCatalogProducts(false);
   
  }


  // handle images method
  onFileSelected(event: any, type: string = 'Normal') {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      if (file.type.startsWith('image/')) {
        const reader = new FileReader();

        reader.onload = () => {
          if (type === 'Normal') {
            this.previewImageUrl = reader.result;
          } else if (type === 'Banner') {
            this.previewBannerUrl = reader.result;
          }
        };

        reader.readAsDataURL(file);
        this.uploadImage(file, false, type);
      }
    }
  }
  private uploadImage(file: File, isCover: boolean, imageType: string): void {
    this.mediaService.upload(file, isCover, this.catalogId, 20).subscribe({
      next: (response) => {

        if (imageType === 'Normal' || imageType === 'Banner') {
          this.sendUpdateCatalogMedia(response.dbPath.tmpUploadFile, imageType);
        }

      },
      error: (err) => {
        console.error('Failed  upload image ', err);
      },
    });
  }

  private sendUpdateCatalogMedia(fileData: any, imageType: string): void {
    const postData = [{
      id: 0,
      fileID: fileData.fileID,
      altText: "string",
      roles: ["string"],
      type: fileData.type,
      originalName: fileData.originalName,
      appInfo: fileData.appInfo,
      mediaLink: fileData.fullPath,
      coverID: "string",
      isLink: true,
      isHidden: true
    }];
    this.uploads(postData, imageType);

  }
  private uploads(data: any, imageType: string) {
    this.subscriptions.push(
      this.productCatalog.updateCatalogMedia(20, this.catalogId, data).subscribe({
        next: (response) => {
          localStorage.setItem(imageType, response);
        },
        error: (error) => {

        }
      })
    );

  }



 private getMediaId(key: string, formKey: string): number | null {

    const localStorageValue = localStorage.getItem(key);
    if (localStorageValue && !isNaN(Number(localStorageValue))) {
      return Number(localStorageValue);
    }

    const formValue = this.catalogForm.get(formKey)?.value;
    if (formValue && !isNaN(Number(formValue))) {
      return Number(formValue);
    }
    return null;
  }
  previewImage(imageType: ImageType, imageUrl: string): void {

    const defaultProductImage = '../../../assets/defaultProductImage.png';

    let finalImageUrl: string | undefined;

    if (imageType === ImageType.Product) {
      finalImageUrl = imageUrl && imageUrl !== '' ? imageUrl : defaultProductImage;
    } else if (imageType === ImageType.Normal) {
      finalImageUrl = this.previewImageUrl || this.thumbUrl;
    } else if (imageType === ImageType.Banner) {
      finalImageUrl = this.previewBannerUrl || this.bannerUrl;
    }


    if (finalImageUrl && typeof finalImageUrl === 'string') {
      this.imageService.preview([
        {
          src: this.satitizer.bypassSecurityTrustUrl(finalImageUrl) as string,
          alt: 'Preview',
        },
      ]);
    }
  }

  removeImage(type: string): void {
    if (type === 'Normal') {
      this.previewImageUrl = '';
      this.thumbUrl = '';
      localStorage.removeItem('Normal');
      this.catalogForm.get('thumbnailMediaObjectId')?.patchValue(null);
    } else if (type === 'Banner') {
      this.bannerUrl = '';
      this.previewBannerUrl = '';
      localStorage.removeItem('Banner');
      this.catalogForm.get('bannerMediaObjectId')?.patchValue(null);
    }
  }


  //Method Filter

  receiveProducts(receiveProducts: any) {
    if(receiveProducts && receiveProducts.length>0){
    this.isFrontPagination=true;
    this.receivedProducts = [...receiveProducts]
    this.handleProductSelection(receiveProducts);
    }else{
      this.displayedProducts=[];
    }

  }

  receiveFilter(event: any) {
    this.filter = event;
  }


    onTabIndexChange(type: string) {
    this.tabIndex = type;
    this.catalogForm.patchValue({ type: type === 'Smart' });
    this.displayedProducts = [];
  }
  // onTabIndexChange(newTabIndex: string) {
  //   this.tabIndex = newTabIndex;
  //   //this.getCatalogProducts();
  //   this.typeCatalog=this.tabIndex==='Smart';
  //   localStorage.setItem(`tabIndex_${this.catalogId}`, newTabIndex);
    
  // }
  
  handleClearCondition() {
  this.isFiltersCleared = true;
  const length=Object.keys(this.filter.filters).length;
  if(length>0){
    this.productCatalog.deleteListPayload(this.catalogId,20).subscribe();
    this.filter={}
  }
  this.displayedProducts = [];    
  this.selectAllCatalogProducts(true, true); 
  console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaa')
  }


  // Pagnation Method
  onPageChange(pageIndex: number) {
    this.productTableParams.index = pageIndex;
    if(!this.isFrontPagination){
    this.getCatalogProducts();
    }
  }
  onPageSizeChange(size: number): void {
    this.productTableParams.size = size;
    this.productTableParams.index = 1;
    this.getCatalogProducts();
  }

  getAllCurrencies() {
    this.productCatalog.getCurrencies().subscribe({
      next: (currency) => {
        this.currencies = currency;

      },
    })

  }
  getAtributes() {
    this.attributesService.getAllAtribute().subscribe({
      next: (data: any) => {

        if (data && data.value && Array.isArray(data.value)) {
          this.attributes = data.value;
          // this.attributes = data.value.filter((attribute: any) => attribute.Type !== 9 && attribute.Type !== 11);
        }
      },
    });
  }

  // Copy Link Catalog
  copyToClipboard() {
    navigator.clipboard.writeText(this.shareableLink).then(() => {
      this.isCopied = true;
      this.message.success('Link copied to clipboard');
      setTimeout(() => {
        this.isCopied = false;
      }, 2000);
    }, err => {
      this.message.error('Failed to copy');
    });
  }


  goToBack(): void {
    const lang = this.route.snapshot.queryParamMap.get('lang') || 'en';
    this.router.navigate(['/product-catalog/catalog-list'], { queryParams: { lang } });
  }

  // Method  get catalog and product image URLs
  getImageUrl(mediaObjectId: number, catalogCode: string): Observable<string | null> {
    if (!mediaObjectId) {
      return of(null);
    }
    return this.productCatalog.getImage({ id: mediaObjectId, catalogCode }).pipe(
      catchError(() => of(null)),
      switchMap(blob => {
        if (!blob) {
          return of(null);
        }
        const url = this.productCatalog.createImageUrl(blob);
        return of(url);
      })
    );
  }

  getImageUrlByCode(imageCode: string): Observable<string | null> {
    if (!imageCode) {
      return of(null);
    }

    return this.mediaService.getMediaByCode(imageCode).pipe(
      catchError(() => of(null)),
      switchMap(blob => {
        if (!blob) {
          return of(null);
        }

        const url = this.productCatalog.createImageUrl(blob);
        return of(url);
      })
    );
  }




loadingProduct = false;
onLoadingChanged(loading: boolean) {
  this.loadingProduct = loading;
}


  override ngOnDestroy(): void {
    this.productCatalog.revokeAll();
    super.ngOnDestroy();
  }

 normalizeFilters(obj: any) {
    if (obj.Filters) {
        obj.filters = obj.Filters; 
        delete obj.Filters; 
    }
}




}
